import { Component, OnInit } from '@angular/core';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { TrackerValuesInterface } from '../tracker-values-element/tracker-values-element.component';

@Component({
  selector: 'sb-comp-tracker-values-element-edit',
  templateUrl: './tracker-values-element-edit.component.html',
  styleUrls: ['./tracker-values-element-edit.component.scss'],
  standalone: false,
})
export class TrackerValuesElementEditComponent implements OnInit {
  count: number;
  unique: number;
  dwellTime: number;
  index: number;

  constructor(private modalNavigation: ModalNavigationService) {
    this.count = null;
    this.unique = null;
    this.dwellTime = null;
    this.index = undefined;
  }

  ngOnInit(): void {
    if (this.modalNavigation.getCurrentNavigation().data) {
      const modalData = this.modalNavigation.getCurrentNavigation().data;
      this.count = modalData.trackerValues.count;
      this.unique = modalData.trackerValues.unique;
      this.dwellTime = modalData.trackerValues.dwellTime;
      this.index = modalData.trackerValues.index;
    }
  }

  countChange($event: number) {
    if ($event && $event > 0) {
      this.count = $event;
    } else {
      this.count = null;
    }
  }

  uniqueChange($event: number) {
    if ($event && $event > 0) {
      this.unique = $event;
    } else {
      this.unique = null;
    }
  }

  dwellTimeChange($event: number) {
    if ($event && $event > 0) {
      this.dwellTime = $event;
    } else {
      this.dwellTime = null;
    }
  }

  close(element?: TrackerValuesInterface) {
    this.modalNavigation.result(element);
  }

  ok() {
    const trackerValues: TrackerValuesInterface = {
      index: this.index,
      unique: this.unique,
      count: this.count,
      dwellTime: this.dwellTime,
    };
    this.close(trackerValues);
  }

  cancel() {
    this.close(null);
  }
}
